import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Col, Layout, message, Modal, Row } from 'antd';
import { get } from 'lodash';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
import queryString from 'query-string';

import PdButton from 'components/pd-button';
import { TableList } from 'components/table-list';

import RentService from 'services/rent';

const { Content } = Layout;
const { confirm } = Modal;

export function BlackoutDate() {
  const location = useLocation();
  const [blackoutDateList, setBlackoutDateList] = useState([]);
  const [loadStatus, setLoadStatus] = useState(false);
  const [page, setPage] = useState(1);
  const [nextPage, setNextPage] = useState(1);
  const navigate = useNavigate();
  const parsed = queryString.parse(location.search);

  const fetchBlackoutDateList = async (page = 1) => {
    try {
      setLoadStatus(true);
      const { data } = await RentService.getBlackoutDate(page);
      const blackout_date = get(data, 'data', []);
      const metadata = get(data, 'metadata', {});

      setBlackoutDateList(blackout_date);
      setNextPage(get(metadata, 'next_cursor', 1));
      setLoadStatus(false);
    } catch (error) {
      message.error(
        get(
          error,
          'response.data.message',
          'Cannot connect to server, please check connection'
        )
      );
    } finally {
      setLoadStatus(false);
    }
  };

  function changePage(page) {
    if (page < 1) page = 1;
    parsed['page'] = page;
    const stringified = queryString.stringify(parsed);
    navigate({
      pathname: '/blackout_dates',
      search: stringified,
    });
  }

  const dateRow = (row) => <div>{dayjs(row.date).format('DD-MM-YYYY')}</div>;

  const tableButton = (row) => (
    <div className="button-table">
      <Row>
        <Col span={12}>
          <PdButton
            type="danger"
            onClick={handleDelete.bind(this, row.id)}
            style={{ width: '90%', height: 32, margin: 5 }}>
            Delete
          </PdButton>
        </Col>
      </Row>
    </div>
  );

  const columns = [
    {
      name: 'Date',
      cell: dateRow,
      width: '30%',
      center: true,
    },
    {
      name: '',
      width: '40%',
      center: true,
    },
    {
      name: '',
      cell: tableButton,
      width: '30%',
      center: true,
    },
  ];

  async function deleteDuration(id) {
    try {
      setLoadStatus(true);
      if (id) {
        await RentService.deleteBlackoutDate(id);
        message.success('Successfully removed date');
      }
    } catch (error) {
      message.error(
        get(
          error,
          'response.data.message',
          'Cannot connect to server, please check connection'
        )
      );
    } finally {
      fetchBlackoutDateList(page);
      setLoadStatus(false);
    }
  }

  const handleDelete = async (id) => {
    confirm({
      title: 'Are you sure you want to delete?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteDuration(id);
      },
      onCancel() {},
    });
  };

  useEffect(() => {
    if (parsed['page']) {
      if (parsed['page'] < 1) {
        parsed['page'] = 1;
        const stringified = queryString.stringify(parsed);
        navigate({
          pathname: '/blackout_dates',
          search: stringified,
        });
      } else {
        setPage(parsed['page']);
      }
    } else {
      setPage('1');
    }

    fetchBlackoutDateList(page);
    // eslint-disable-next-line
  }, []);

  return (
    <Layout className="pd-cms-durations main-container">
      <div className="content">
        <div className="pageTitle">Blackout Date</div>
        <Content className="pageContent">
          <Row>
            <Col span={3} offset={19}>
              <Link to="/blackout_dates/create">
                <PdButton
                  type="primary"
                  full
                  outline
                  style={{ height: 32, width: 176 }}>
                  Add New Blackout Date
                </PdButton>
              </Link>
            </Col>

            <Col xs={24} className="">
              <TableList
                changePage={changePage}
                columns={columns}
                loadingOrder={loadStatus}
                nextPage={nextPage}
                orderList={blackoutDateList}
                page={page}
                responsive={false}
              />
            </Col>
          </Row>
        </Content>
      </div>
    </Layout>
  );
}

export default { BlackoutDate };
